<AuthContainer><component :key="metaProvidedComponent" :is="metaProvidedComponent" v-if="metaProvidedComponent"></component></AuthContainer>